'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeCart = require('@shopify/theme-cart');

var cart = _interopRequireWildcard(_themeCart);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)('*');

document.addEventListener('homepage', loadIndex);

if ((0, _jquery2.default)('body').hasClass('template-homepage')) {
  //loadIndex();

}

var formHeight = (0, _jquery2.default)('.product-item form').height();

function matchHeights() {
  // match product item heights
  (0, _jquery2.default)('.product-item form').each(function () {
    var $this = (0, _jquery2.default)(this);
    if ($this.height() > formHeight) {
      var diff = $this.height() - formHeight;
      formHeight = $this.height();
      //$this.css('margin-top', `-${diff}px`);
    }
  });
}
(0, _jquery2.default)(window).on('resize', matchHeights);
function loadIndex() {
  var $cloned = (0, _jquery2.default)('#Cloned');

  matchHeights();

  //$('.product-item form').css('height', formHeight);

  (0, _jquery2.default)('#subForm input[type="email"]').on('keydown blur', function () {
    console.log('input' + (0, _jquery2.default)(this).val().length);
    if ((0, _jquery2.default)(this).val().length > 1) {
      (0, _jquery2.default)('#subForm button').addClass('active');
    } else {
      (0, _jquery2.default)('#subForm button').removeClass('active');
    }
  });

  if ($cloned.length > 0) {
    (0, _jquery2.default)(window).off('scroll').on('scroll', function () {
      var st = (0, _jquery2.default)(window).scrollTop();
      if (st >= $cloned.position().top) {
        (0, _jquery2.default)(window).scrollTop(0);
      }
    });
  }

  if ((0, _jquery2.default)('[data-add-to-cart]').length > 0) {
    (0, _jquery2.default)('[data-add-to-cart]').on('click', function (e) {
      e.preventDefault();
      console.log('add to cart');
      var $product = (0, _jquery2.default)(this).closest('.product-item');
      var selected_id = Number($product.find('[data-product-select]').val()),
          qty = 1;

      var $button = (0, _jquery2.default)(this);

      cart.addItem(selected_id, { quantity: qty }).then(function (item) {
        cart.getState().then(function (state) {
          console.log(state);
          (0, _jquery2.default)('.cart-count').text(state.item_count);
          (0, _jquery2.default)('.cart-counter').show();
          (0, _jquery2.default)('.cart-counter').parent().addClass('active blue');
        });
        console.log('An item with a quantity of ' + qty + ' was added to your cart:', item);

        //flip text
        $product.find('[data-add-to-cart-text]').text('added').css({ 'color': 'black' });
        $product.find('[data-add-to-cart-text]').parent().css('pointer-events', 'none');

        setTimeout(function () {
          $button.find('[data-add-to-cart-text]').text($button.attr('data-cta')).css({ 'color': '' });
          $button.find('[data-add-to-cart-text]').parent().css('pointer-events', 'auto');
        }, 2000);
      });
    });
  }
}